import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { IonSlides, ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { distinctUntilChanged, Subscription } from "rxjs";
import * as _ from "lodash";
import * as fromApp from "../../../store/app.reducer";
import { DataStorageService } from "src/app/services/data-storage/data-storage.service";
import { PreviousOrderModalComponent } from "../previous-order-modal/previous-order-modal.component";
import * as PreviousOrdersActions from "../../../catalog/previous-order/store/previousOrders.actions";
import { from, Observable } from "rxjs";
import * as selectors from "../../../store/app.selectors";

@Component({
  selector: "app-previous-orders-slider",
  templateUrl: "./previous-orders-slider.component.html",
  styleUrls: ["./previous-orders-slider.component.scss"],
})
export class PreviousOrdersSliderComponent implements OnInit, OnDestroy {
  @ViewChild("previousOrdersSlider") slider: IonSlides;
  public isBeginning: Observable<boolean>;
  public isEnd: Observable<boolean>;
  public previousOrders: any;
  public currentUser: any;
  public browserPlatform: any;
  public groupApp: any;
  public store_info: any;
  public webp: any;
  private authSubscription: Subscription;
  private previousOrdersSubscription: Subscription;
  private storeInfoSub: Subscription;
  public sliderOptions = {
    allowTouchMove: true,
    slidesPerView: "auto",
    direction: "horizontal",
    slideToClickedSlide: true,
    mousewheel: true,
    freeMode: true,
    freeModeMomentumBounce: false,

    // autoplay:true,
    spaceBetween: 2,

    watchSlidesVisibility: true,
  };
  private previousOrderModal: any;

  constructor(
    private store: Store<fromApp.AppState>,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.authSubscription = this.store
      .select("auth")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && !_.isEqual(state.user, this.currentUser)) {
          this.currentUser = _.cloneDeep(state.user);
        }
      });

    this.previousOrdersSubscription = this.store
      .select("previousOrders")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && !_.isEqual(state.previousOrders, this.previousOrders)) {
          this.previousOrders = _.cloneDeep(state.previousOrders);

          console.log("previous orders", this.previousOrders);
        }
      });

    this.storeInfoSub = this.store
      .select(selectors.getStoreInfo)
      .pipe(distinctUntilChanged())
      .subscribe((storeInfo) => {
        if (storeInfo && !_.isEqual(this.store_info, storeInfo)) {
          this.store_info = _.cloneDeep(storeInfo);
        }
      });
  }

  trackOrders(index, order) {
    return order.order_id.toString() + "_" + order.store_id.toString();
  }

  nextSlide() {
    if (this.slider) {
      this.slider.slideNext();
    }
  }

  prevSlide() {
    if (this.slider) {
      this.slider.slidePrev();
    }
  }

  updateSliderIconState() {
    this.isEnd = from(this.slider.isEnd());
    this.isBeginning = from(this.slider.isBeginning());
  }

  showPreviousOrderModal(selectedOrder) {
    this.store.dispatch(
      new PreviousOrdersActions.SetPreviousOrderCart(
        _.cloneDeep(selectedOrder.products)
      )
    );

    this.presentPreviousOrderModal(selectedOrder.order_id);
  }

  async presentPreviousOrderModal(order_id) {
    this.previousOrderModal = await this.modalController.create({
      component: PreviousOrderModalComponent,
      cssClass: "previousOrderModal",
      animated: true,
      componentProps: { previousOrderId: order_id },
      backdropDismiss: false,
    });

    await this.previousOrderModal.present();
    this.previousOrderModal.onDidDismiss().then(() => {
      this.previousOrderModal = null;
    });
  }

  ngOnDestroy() {
    if (this.previousOrderModal) {
      this.previousOrderModal.dismiss();
      this.previousOrderModal = null;
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.previousOrdersSubscription) {
      this.previousOrdersSubscription.unsubscribe();
    }
    if (this.storeInfoSub) {
      this.storeInfoSub.unsubscribe();
    }
  }
}
